import { LoadableData } from '../../../common/utils/LoadableData';
import { ReducerFactory } from 'redux-actions-ts-reducer';
import { boCompanyDetailsLoadableActions } from './BOCompanyDetailsViewActions';
import { GlobalState } from '../../../rootReducer';
import { BackOfficeCompanyDTO } from '../../../services/types/BoApiTypes';
import { LOCATION_CHANGE } from 'connected-react-router';

class State {
    boCompanyDetailsLoadable = new LoadableData<BackOfficeCompanyDTO, string>();
    addOrEditBoCompanyLoadable = new LoadableData<BackOfficeCompanyDTO, BackOfficeCompanyDTO>();
}

export default new ReducerFactory(new State())
    .addReducer(boCompanyDetailsLoadableActions.request, (state, action) => {
        return {
            ...state,
            boCompanyDetailsLoadable: LoadableData.loading(action.payload),
        };
    })
    .addReducer(boCompanyDetailsLoadableActions.success, (state, action) => {
        return {
            ...state,
            boCompanyDetailsLoadable: LoadableData.payload(action.payload),
        };
    })
    .addReducer(
        LOCATION_CHANGE,
        (): State => {
            return { ...new State() };
        },
    )
    .toReducer();

export { State as BOCompanyDetailsViewState };

export const selectBOCompanyDetailsLoadable = (state: GlobalState) => state.boCompanyDetails.boCompanyDetailsLoadable;
